import { Record } from 'immutable'

const UpdateCalculationConstantRecord = Record({
  name: '',
  symbol: '',
  unit: '',
})

export default UpdateCalculationConstantRecord
